import { Component } from 'react';
import { connect } from 'react-redux';
import CKEditor from '../ckeditor4';
import ArrowButton from '../../button-arrow';
import { getEnvironmentVariable } from '../../../../actions/environment-variable';

import './index.css';

class AdminEditor extends Component {
    state = {
      content: '',
      identifier: ''
    };

    handleClick = () => {
      this.props.dispatch(this.props.onClickAction({identifier: this.state.identifier, content: this.state.content}));
    }

    updateContent = (newContent) => {
      this.setState({
        content: newContent
      });
    };

    UNSAFE_componentWillMount() {
      this.setState({
        identifier: this.props.identifier,
        content: this.props.content || ''
      });
      if (this.props.licenseKey.length === 0) {
        this.props.dispatch(getEnvironmentVariable('REACT_APP_CKEDITOR_LICENSE_KEY'));
      }
    }

    render() {
      const { content, identifier } = this.state;
      const { editorTitle } = this.props;

      if (this.props.licenseKey.length === 0) {
        return (
          <div>Loading editor...</div>
        );
      }

      return (
        <div key={identifier} className='admin-editor' >
          {editorTitle && <h3>{editorTitle}</h3>}
          <CKEditor
            scriptUrl="/api/ckeditor/ckeditor.js"
            content={content}
            events={{
              change: event => this.updateContent(event.editor.getData())
            }}
            config={{
              versionCheck: false,
              licenseKey: this.props.licenseKey
            }}
          >
          </CKEditor>

          <ArrowButton
            className='float-right btn-block admin-editor-save'
            arrow={false}
            onClick={this.handleClick}
          >Save
          </ArrowButton>
        </div>
      );
    }
}

const mapStateToProps = state => ({
  licenseKey: state.environmentVariable.environmentVariableValue
});

export default connect(mapStateToProps)(AdminEditor);
